var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"shape-img subscribe-wrap",class:_vm.isGray ? 'gray-light-bg' : '',attrs:{"id":"wave"}},[_c('img',{staticClass:"img-fluid",attrs:{"alt":"footer shape","src":"img/footer-top-shape.png"}})])}
var staticRenderFns = []

export { render, staticRenderFns }